export enum BackendApiErrorKind {
  NotAuthenticated = "NOT_AUTHENTICATED",
}
